import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { roundsDataAtom, streamVideoRangesAtom } from '../state/index.ts';
import { raceDataAtom } from './race-atoms.ts';
import { buildStreamLinkForTimestamp } from '../stream/stream-utils.ts';
import { parseTimestampMs } from '../common/time.ts';

interface RaceNumberProps {
	raceId: string;
}

export function RaceNumber({ raceId }: RaceNumberProps) {
	const roundData = useAtomValue(roundsDataAtom);
	const race = useAtomValue(raceDataAtom(raceId));
	const streamRanges = useAtomValue(streamVideoRangesAtom);

	const raceStartMs = useMemo(() => parseTimestampMs(race?.start ?? null), [race?.start]);
	const raceStreamLink = useMemo(
		() => buildStreamLinkForTimestamp(streamRanges, raceStartMs),
		[streamRanges, raceStartMs],
	);

	if (!race) return null;

	const round = roundData.find((r) => r.id === (race.round ?? ''));
	const roundLabel = round?.name || (round?.roundNumber ? `Round ${round.roundNumber}` : 'Round');
	const raceLabel = race.raceNumber != null ? `Race ${race.raceNumber}` : `Order ${race.raceOrder}`;
	const displayLabel = `${roundLabel} — ${raceLabel}`;

	return (
		<div className='race-number'>
			{raceStreamLink
				? (
					<a
						href={raceStreamLink.href}
						target='_blank'
						rel='noreferrer'
						title={`Watch ${raceStreamLink.label}${raceStreamLink.offsetSeconds > 0 ? ` (+${raceStreamLink.offsetSeconds}s)` : ''}`}
					>
						{displayLabel}
					</a>
				)
				: displayLabel}
		</div>
	);
}
